<script>
  import _ from 'lodash'
  import VueTypes from 'vue-types'
  import ThemeQuestionField from '../components/theme-question-field-for-profit'
  import ThemeQuestionsForm from '../components/theme-questions-form'

  export default {
    template: '#theme-questions-form-for-profit-template',
    name: 'ThemeQuestionsFormForProfit',
    mixins: [ThemeQuestionsForm],
    components: {
      'theme-question-field': ThemeQuestionField,
    },
  }
</script>
